<div fxLayout="column" fxLayoutAlign="start center" class="dashboard">
  <gridster [options]="gdOptions" class="gridster">
    <gridster-item
      [item]="item"
      *ngFor="let item of gdItems"
      [ngClass]="{ 'config-hidden': !hasPermission(item) }"
    >
      <div
        *ngIf="gdOptions.draggable.enabled === true"
        style="
          position: absolute;
          right: 5px;
          top: 5px;
          z-index: 10;
          height: 40px;
          width: 40px;
        "
      >
        <button
          mat-mini-fab
          [style.background]="buttonColor"
          (click)="onGridsterDelete($event, item)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div
        *ngIf="gdOptions.draggable.enabled === true"
        style="
          position: absolute;
          right: 65px;
          top: 5px;
          z-index: 10;
          height: 40px;
          widows: 40px;
        "
      >
        <button
          mat-mini-fab
          [style.background]="buttonColor"
          (click)="onGridsterConfig($event, item)"
        >
          <mat-icon>settings</mat-icon>
        </button>
      </div>
      <ng-container [appDynamicContainer]="item.name"></ng-container>
    </gridster-item>
  </gridster>
</div>
